exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.import-step[data-v-3728ae9f] {\n\tmin-height: 120px;\n}\n.import-upload[data-v-3728ae9f] .el-upload-dragger {\n\twidth: 100%;\n}\n.import-upload[data-v-3728ae9f] .el-upload {\n\twidth: 100%;\n}\n", ""]);

// exports
